import { DISPATCHER, DRIVER, MANAGER, SUPERADMIN, SUPERVISOR } from "constants/constants";

export const defaultUserData = {
  autocreated: false,
  date_joined: "",
  date_of_birth: "",
  email: "",
  first_name: "",
  id: 0,
  badge: null,
  is_staff: false,
  is_superuser: false,
  last_login: "",
  last_name: "",
  mobile_number: "",
  role: 0,
  role_name: "",
  training_delivered: false,
  transporter_id: "",
  van_group: {
    description: "",
    id: 0,
    name: "",
    supervisor: 0,
  },
  personal_email: "",
  whatsapp_mobile_number: "",
  driver_license: "",
  driver_license_expiry: "",
  knet_user: "",
  agency_name: {
    description: "",
    id: 0,
    name: "",
  },
  tenured: 0,
  station_spots: [],
  can_create_old_shifts: false,
};

export const defaultNavLinkList = [
  {
    id: "dashboard",
    name: "Dasboard",
    permissionKey: [DISPATCHER, SUPERVISOR, MANAGER, SUPERADMIN],
    subList: [],
  },
  {
    id: "falcon",
    name: "Falcon",
    permissionKey: [SUPERADMIN, SUPERVISOR, MANAGER],
    subList: [],
  },
  {
    id: "operations",
    name: "Operations",
    permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
    subList: [
      {
        id: "shift-tracker",
        name: "Shift Tracker",
        permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      },
      {
        id: "schedule",
        name: "Schedule",
        permissionKey: [DISPATCHER, SUPERVISOR, SUPERADMIN, MANAGER],
      },
      // {
      //   id: "prime-schedule",
      //   name: "Prime Schedule",
      //   permissionKey: [DISPATCHER, SUPERVISOR, SUPERADMIN, MANAGER],
      // },
      {
        id: "tracker",
        name: "Tracker",
        permissionKey: [SUPERVISOR, SUPERADMIN, MANAGER],
      },
    ],
  },
  {
    id: "amzn-reports-main",
    name: "AMZN Reports",
    permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
    subList: [
      {
        id: "perfomance",
        name: "Perfomance",
        permissionKey: [MANAGER, SUPERADMIN, SUPERVISOR],
      },
      {
        id: "scoreboard",
        name: "Scoreboard",
        permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      },
      {
        id: "check-amzn",
        name: "Check AMZN",
        permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      },
      {
        id: "act-amzn",
        name: "Act AMZN",
        permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      },
    ],
  },
  // {
  //   id: "graphs",
  //   name: "Graphs",
  //   permissionKey: [SUPERADMIN],
  //   subList: [],
  // },
  {
    id: "pulse",
    name: "Pulse",
    permissionKey: [MANAGER, SUPERADMIN, SUPERVISOR],
    subList: [],
  },
  {
    id: "import",
    name: "Import",
    permissionKey: [SUPERVISOR, MANAGER, SUPERADMIN],
    subList: [],
  },
  {
    id: "human-resources",
    name: "Human Resources",
    permissionKey: [SUPERVISOR, DISPATCHER, SUPERADMIN, MANAGER],
    subList: [
      {
        id: "da-setup",
        name: "DA status",
        permissionKey: [SUPERVISOR, DISPATCHER, MANAGER, SUPERADMIN],
      },
      {
        id: "payroll",
        name: "Payroll",
        permissionKey: [SUPERADMIN],
      },
    ],
  },
  {
    id: "fleet",
    name: "Fleet",
    permissionKey: [SUPERVISOR, DISPATCHER, SUPERADMIN, MANAGER],
    subList: [
      {
        id: "fleet-setup",
        name: "Fleet status",
        permissionKey: [SUPERVISOR, DISPATCHER, MANAGER, SUPERADMIN],
      },
      {
        id: "fleet-reports",
        name: "Fleet Reports",
        permissionKey: [SUPERADMIN],
      },
    ],
  },
  {
    id: "da-home",
    name: "Home",
    permissionKey: [DRIVER],
    subList: [],
  },
  {
    id: "da-action",
    name: "Action",
    permissionKey: [DRIVER],
    subList: [],
  },
];
